import React, { useEffect, useState } from "react";
import { connect, useSelector, useDispatch } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";
import queryString from "query-string";
import { Alert } from "react-bootstrap";
import {
  getBots,
  getIndicators,
  getRentalBots,
  getSubscription
} from "../../actions/bot-action";

import "./Bots.scss";

import ContentContainer from "../common/ContentContainer";

import { getBotDetail } from "../../actions/bot-action";

import {
  resetBotConfig,
  updateEditBotConfig,
  updatePresetConfig,
  updateCopyBotConfig,
  updateEditRentBotConfig
} from "../../actions/create-bot-action";
import { getDashboardAssets } from "../../actions/dashboard-action";

import { useTranslation } from "react-i18next";
import BalanceInfo from "./BalanceInfo";
import RentedList from "./RentedList";
import RentalFilterPanel from "./RentalFilterPanel";

const Rentals = (props) => {
  const {
    getSubscription,
	getDashboardAssets
  } = props;
  const { t } = useTranslation()
  const selectedExchangeId =
    useSelector((state) => state.settings.selectedExchangeId) || 0;
  const itemsPerPage = 12;
  const fiatBalance = useSelector((state) => state.dashboard.assets.balance_fiat);
  const status = useSelector((state) => state.pagination.botsActiveTab) || "all";
  const newUserIntroPupup = useSelector((state) => state.settings.newUserIntroPupup);
  
  const [searchBotName, setSearchBotName] = useState("");
  
  const location = useLocation();
  const history = useHistory();
  const query = queryString.parse(location.search);
  const [showSubscriptionNotice, setShowSubscriptionNotice] = useState(query.subscriptionSuccess === "true");

  const closeNotice = () => {
    setShowSubscriptionNotice(false);
    history.replace("/rented-strategies");
  };

  useEffect(() => {
    getSubscription();
    getDashboardAssets(selectedExchangeId)
    getRentalBots(selectedExchangeId,itemsPerPage,1,'','','',searchBotName);
  }, [selectedExchangeId]);

  return (
      <ContentContainer url="rented-strategies" title={t("mr")} showChat={true}>
        <div className="dashboard-newuser-area">
              <BalanceInfo selectedExchangeId={selectedExchangeId}></BalanceInfo>

              {showSubscriptionNotice && (
                <Alert variant="success" onClose={closeNotice} dismissible className="rental-subscription-notice mt-3">
                  <div className="notice-content">
                    <h4 className="notice-title">Thank you for subscribing to StockHero!</h4>
                    <p className="notice-body">
                      Your free strategies have now been added to your account and are available on this page.<br/>
                      To get started, please <a href="https://docs.stockhero.ai/getting-started/deploying-a-marketplace-bot" target="_blank" rel="noopener noreferrer" className="notice-link">read this article</a> for step-by-step instructions on creating a bot using a Marketplace strategy.
                    </p>
                    <p className="notice-footer"><strong>If the strategies don’t appear immediately, simply refresh the page after 30 seconds.</strong></p>
                  </div>
                </Alert>
              )}

              <div className="deshboard-normal-allBots-area">
								<div className="deshboard-normal-allBots-header">
									<h3>My Rented Strategies</h3>

                  <div className="deshboard-normal-allBots-header-right">
										<RentalFilterPanel status={status} searchBotName={searchBotName} setSearchBotName={setSearchBotName}></RentalFilterPanel>
									</div>
									
								</div>
								<div className="deshboard-normal-allBots-body">
									
									<div className="dna-cart-content">
										<div className="row g-3">
											<RentedList t={t} searchBotName={searchBotName}></RentedList>
										</div>
									</div>
									
								</div>
							</div>
            </div>
      
      </ContentContainer>
  );
};

export default connect(null, {
  getBots,
  getSubscription,
  updateEditBotConfig,
  updateEditRentBotConfig,
  resetBotConfig,
  updatePresetConfig,
  getIndicators,
  updateCopyBotConfig,
  getBotDetail,
  getRentalBots,
  getDashboardAssets
})(Rentals);
